import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation createInvoiceEntryMutation($input: CreateInvoiceEntryInput!) {
		createInvoiceEntry(input: $input) {
			invoiceEntry {
				node {
					id
					name
					quantity
					unitPrice
					discount
					tax
					description
					quickbooksItemOrService
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.invoiceId,
			connectionInfo: [
				{
					key: 'Invoice_entries',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'invoiceEntry',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		createInvoiceEntry: {
			invoicePayment: {
				node: {
					name: input.name,
					quantity: input.quantity,
					unitPrice: input.unitPrice,
					discount: input.discount,
					tax: input.tax,
					description: input.description,
					quickbooksItemOrService: input.quickbooksItemOrService,
				},
			},
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Invoice Entry Created');
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
